// Shared runtime for the AP "Make an Enquiry" triggers (Shape 3 in
// docs/maintenance/drawer-architecture.md). Serves both the Bride enquiry buttons
// (blocks/ap-enquiry-buttons.liquid) and the sold-out enquiry trigger
// (blocks/_ap-sold-out-enquiry.liquid); the markup contract they share lives in
// snippets/ap-enquiry-trigger.liquid.
//
// The trigger is rendered as a link to a fallback page. When the drawer it names is
// present, this intercepts the click and opens the drawer instead of navigating. With no
// drawer on the page — or with JavaScript disabled — the link navigates natively, which
// is the whole reason the trigger is an anchor and not a declarative on:click.
//
// The drawer to open comes from the trigger's own `data-ap-enquiry-trigger` value, so one
// page can host several enquiry drawers (contact vs product enquiry) without collision. A
// blank value keeps the historical default, so triggers written before the attribute
// carried a value keep working unchanged.
//
// Product context (data-context-*) is copied into the drawer's <ap-form-product-context>
// on the way in, so the form shows — and the Gorgias ticket carries — the variant the
// customer actually had selected when they pressed the button. Triggers without context
// attributes simply leave the drawer's server-rendered values alone.
const DEFAULT_DRAWER_SELECTOR = '#ap-contact-drawer';

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const trigger = event.target.closest('[data-ap-enquiry-trigger]');
  if (!(trigger instanceof HTMLElement)) return;

  const drawer = document.querySelector(trigger.dataset.apEnquiryTrigger || DEFAULT_DRAWER_SELECTOR);
  if (!drawer || typeof drawer.showDialog !== 'function') return;

  event.preventDefault();

  const context = drawer.querySelector('ap-form-product-context');
  if (context && typeof context.applyContext === 'function') context.applyContext(trigger.dataset);

  drawer.showDialog();
});
